import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ListItem from "@material-ui/core/ListItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import { withStyles } from "@material-ui/core/styles";
import { withTheme } from "@material-ui/core/styles";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { Trans, withTranslation } from "react-i18next";

const styles = (theme) => ({
  listItem: {
    display: "flex",
    paddingRight: "3px",
  },
  contentWrapper: {
    display: "flex",
  },
  sticky: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    background: "white",
    cursor: "pointer",
  },
  tableRow: {
    cursor: 'pointer',
  }
});

export class KpsListItem extends Component {
  static propTypes = {
    isPortlet: PropTypes.bool.isRequired,
    onItemClick: PropTypes.func.isRequired,
  };

  state = {
    extendedString: "",
    expanded: false,
  };

  render() {
    const { theme, classes } = this.props;
    let draggableProps;
    if (this.props.provided) {
      draggableProps = this.props.provided.draggableProps;
    }
    return (
      <>
        {this.props.fullscreen === true || this.props.menuDialog ? (
          <>
            <TableRow onClick={this.onClick} hover={true} classes={{ hover: classes.tableRow}}>
              <>
                {this.props.secondaryAction &&
                  this.props.secondaryAction !== null && (
                    <TableCell className={classes.sticky}>
                      {this.props.secondaryAction}
                    </TableCell>
                  )}
              </>
              <TableCell>
                <div style={{ display: "flex" }}>
                  <div style={{ marginRight: theme.spacing(2) }}>
                    {this.props.rowExpander &&
                      (this.props.rowExpanderState === true ? (
                        <ExpandLessIcon />
                      ) : (
                        this.props.rowExpanderState === false && (
                          <ExpandMoreIcon />
                        )
                      ))}
                  </div>
                  <div>{this.props.children}</div>
                </div>
              </TableCell>
              {this.props.fullscreenSettings}
            </TableRow>
            {this.props.rowExpander &&
              this.props.rowExpanderState === true && (
                <TableRow>
                  <TableCell
                    colSpan={
                      this.props.fullscreenSettings &&
                      this.props.fullscreenSettings.props
                        ? this.props.fullscreenSettings.props.children.length +
                          1
                        : this.props.fullscreenSettings &&
                          this.props.fullscreenSettings.length > 1
                          ? this.props.fullscreenSettings.length + 1
                          : 1
                    }
                  >
                    {this.props.rowExpander}
                  </TableCell>
                </TableRow>
              )}
          </>
        ) : (
          <div {...draggableProps} style={{ width: "100%" }}>
            <ListItem
              button
              onClick={(e) => {
                if (this.props.expandOnClick) {
                  this.toggleExpand(e);
                }
                this.props.onItemClick && this.props.onItemClick();
              }}
              aria-label={this.props.ariaLabel}
              className={classes.listItem}
              style={{
                paddingLeft: this.props.preText || this.props.isMobile ? 0 : 10,
                borderRight: this.props.selected
                  ? `2px solid ${this.props.theme.palette.primary.main}`
                  : "",
              }}
              ContainerComponent="div"
              disableGutters={true}
              dense={true}
              selected={this.props.selected}
            >
              {this.props.icon && (
                <ListItemIcon>{this.props.icon}</ListItemIcon>
              )}
              {this.props.children}
              {!this.props.hideExpand && (
                <IconButton
                  onClick={this.toggleExpand}
                  aria-label={
                    this.state.expanded ? "Show less info" : "Show more info"
                  }
                >
                  {this.state.expanded ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </IconButton>
              )}
              {this.props.secondaryAction && this.props.secondaryAction}
            </ListItem>
            {!this.props.hideExpand && (
              <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
                <Table
                  size="small"
                  style={{ overflowWrap: "anywhere" }}
                  tabindex={0}
                  aria-label="Extended item information"
                >
                  <TableBody>{this.props.extendedString}</TableBody>
                </Table>
              </Collapse>
            )}
          </div>
        )}
      </>
    );
  }

  onClick = (e) => {
    e.preventDefault();
    this.props.onItemClick && this.props.onItemClick();
    // localStorage.setItem("fullscreenPortletItemClicked", true);
  };

  toggleExpand = (e) => {
    // this.props.onToggle && this.props.onToggle(!this.state.expanded);
    this.setState((prev) => ({ expanded: !prev.expanded }));
    e.preventDefault();
    e.stopPropagation();
  };
}

const mapStateToProps = (state) => ({
  settings: state.setting.searchSettings,
  properties: state.setting.applicationProperties,
  isMobile: state.screen.isMobile,
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withTheme(withTranslation()(KpsListItem))));
